if (!customElements.get('before-after-slider-pdp')) {
  customElements.define(
    'before-after-slider-pdp',
    class BeforeAfterSliderPdp extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        // Splide is loaded globally by other sections; wait for it to be ready.
        this.whenSplideReady(() => this.init());
      }

      whenSplideReady(cb, tries = 0) {
        if (typeof window.Splide !== 'undefined') return cb();
        if (tries > 60) {
          console.error('[before-after-slider-pdp] Splide library not available');
          return;
        }
        setTimeout(() => this.whenSplideReady(cb, tries + 1), 50);
      }

      init() {
        try {
          const mainEl = this.querySelector('.js-main-carousel');
          if (!mainEl) return;

          const main = new window.Splide(mainEl, {
            type: 'slide',
            arrows: false,
            pagination: false,
            perPage: 1,
            speed: 400
          });

          const thumbs = Array.from(this.querySelectorAll('.js-ba-thumb'));
          const progressBar = this.querySelector('.js-progress-bar');

          const setActive = (idx) => {
            thumbs.forEach((t, i) => t.classList.toggle('is-active', i === idx));
            if (progressBar && thumbs.length) {
              const total = thumbs.length;
              progressBar.style.width = `${100 / total}%`;
              progressBar.style.left = `${(100 * idx) / total}%`;
            }
          };

          main.on('mounted move', () => setActive(main.index));
          main.mount();

          thumbs.forEach((thumb, i) => {
            thumb.addEventListener('click', () => main.go(i));
          });

          setActive(main.index);
        } catch (error) {
          console.error('[before-after-slider-pdp] init error:', error);
        }
      }
    }
  );
}
